import { all } from "redux-saga/effects";
import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";

import { authReducerActions } from "../app/modules/Auth";
import { authReducer, authSaga } from "../app/modules/Auth";
import { dsReducer, dsSaga } from "../app/modules/Dashboard";
import { rtReducer, rtSaga } from "../app/modules/ReceiptTracking";
import { rmReducer, rmSaga } from "../app/modules/ReceiptManagement";
import { uiReducer, uiSaga } from "../app/modules/UI";
import { refReducer, refSaga } from "../app/modules/Administration/ReferenceInfoManagement";
import { agencyReducer, agencySaga } from "../app/modules/Administration/AgencyManagement";
import { serviceReducer, serviceSaga } from "../app/modules/Administration/ServiceManagement";
import { serviceItemReducer, serviceItemSaga } from "../app/modules/Administration/ServiceItemManagement";
import { reportReducer, reportSaga } from "../app/modules/Reporting";
import { provinceSaga, provinceReducer } from "../app/modules/Administration/ProvinceInfoManagement";


const appReducer = combineReducers({
  auth: authReducer,
  ui: uiReducer,
  reference: refReducer,
  agency: agencyReducer,
  services: serviceReducer,
  serviceItem: serviceItemReducer,
  dashboard: dsReducer,
  receiptTracking: rtReducer,
  reports: reportReducer,
  province: provinceReducer,
  receiptManagement: rmReducer
});

export const rootReducer = (state, action) => {
  if ( action.type.localeCompare(authReducerActions.loggedOut) === 0) {
    // for all keys defined in your persistConfig(s)
    storage.removeItem('persist:user-access-key');
    storage.removeItem('persist:root');
    state = undefined;
  }
  return appReducer(state, action);
};


export function* rootSaga() {
  yield all([
    authSaga(),
    uiSaga(),
    dsSaga(),
    rtSaga(),
    refSaga(),
    agencySaga(),
    serviceSaga(),
    serviceItemSaga(),
    reportSaga(),
    provinceSaga(),
    rmSaga()
  ]);
};